// extracted by mini-css-extract-plugin
export default {"splashScreenContainer":"style_splashScreenContainer__w67kf","progressContainer":"style_progressContainer__ZBTbV"};